import React from 'react';
import "../../ReusableComponent/CIVIL/CivilBatchSection/CivilBatch.css";
import civilopt from "../../../Image/civilopt.png";
import civilcard1 from "../../../Image/civilcard1.jpg";
import civilcrad2 from "../../../Image/civilcrad2.jpg";
import civilcard3 from "../../../Image/civilcard3.jpg";
import civilcard4 from "../../../Image/civilcard4.jpg";
import civilcard5 from "../../../Image/civilcard5.jpg";
import CivilBatch from '../../ReusableComponent/CIVIL/CivilBatchSection/CivilBatch';
import CivilButton from '../../ReusableComponent/CIVIL/CivilButton/CivilButton';
import { Helmet } from 'react-helmet-async';

function CivilOpt() {
  const componentName = "civilHistory";
  const data = {
    CourseTitle: 'History Optional Map Classes',
    BatchName: 'Batch-1',
    Bdate: "08 Jan,2026",
    Subscriber: "6",
    TopicCount: "6",
    Price: 3950,
    Discount: 50,
    Topic: "This Map Course has been specially designed by taking into account the demands of Paper-I of History Optional Mains Examination. The classes will equip the candidates in the development of comprehensive understanding of various Map locations to score 40-45 Marks easily.",
    Image: civilopt,
    VideoId: "p2JiU-cuXIo",
    SyllabusPdf: "https://insightdelhi.com/syllabus/history-map.pdf",
    isEnrolled: false,
    Description: [
      {
        text: "",
        styles: [
          { word: "", style: 'font-weight: bold;' },
        ],
        video: {
          src: "https://www.youtube.com/embed/p2JiU-cuXIo?si=JxOti6TVWiKCgeAb",
          alt: "YouTube video player",
          title: "YouTube video player",
        },
      },
      {
        text: "This Map Course has been specially designed by taking into account the demands of Paper-I of History Optional Mains Examination. The classes will equip the candidates in the development of comprehensive understanding of various Map locations to score 40-45 Marks easily. No prior knowledge of any kind is needed for this course.",
        styles: [
          { word: "This Map Course has been specially designed by taking into account the demands of Paper-I of History Optional Mains Examination. The classes will equip the candidates in the development of comprehensive understanding of various Map locations to score 40-45 Marks easily. No prior knowledge of any kind is needed for this course.", style: 'background: whitesmoke; display: block; padding: 1vmax;' },
          { word: "specially designed by taking into account the demands of Paper-I", style: 'font-weight: bold;' },
          { word: "score 40-45 Marks", style: 'font-weight: bold;' },
        ]
      },
      {
        text: "SPECIAL FEATURES OF MAP COURSE",
        lists: [
          "This Map Course has been specially designed by taking into account the demands of Paper-I of History Optional Mains Examination. All the issues of Map which is part of Paper-I of History Optional will be covered in detail during classes.",
          "The classes will equip the candidates in the development of comprehensive understanding of various Map locations to score 40-45 Marks easily.",
          "No prior knowledge of any kind is needed for this course. The course has been formulated in such a way that even those students, who do not have even basic knowledge of Map, will be able to get complete understanding of the Map related issues.",
          "During the course emphasis will be placed upon the development of understanding of the subject matter rather than simply cramming the facts and figures.",
          "Newly developed computerised Study Material will be provided to all the students.",
          "Validity of the Course: 15 Days",
        ],
        styles: [
          { word: 'SPECIAL FEATURES OF MAP COURSE', style: 'font-weight: bold; color: #C00000; background: whitesmoke; display: block; padding: 1vmax;' },
          { word: "specially designed by taking into account the demands of Paper-I", style: 'font-weight: bold;' },
          { word: "score 40-45 Marks", style: 'font-weight: bold;' },
          { word: "No prior knowledge of any kind is needed for this course.", style: 'font-weight: bold;' },
          { word: "emphasis will be placed upon the development of understanding of the subject", style: 'font-weight: bold;' },
          { word: "computerised Study Material", style: 'font-weight: bold;' },
          { word: "Validity of the Course: 15 Days", style: 'font-weight: bold;' },
        ]
      },
    ],
    staticSubjects: [
      { Sn: 1, Subject: 'History Optional Map Classes' }
    ],
    staticLessons: [
      { Title: 'Map Booklet', SubjectID: 1, lessonURL: 'map-booklet' },
      { Title: 'MAP CLASS-1', SubjectID: 1, lessonURL: 'map-class-1' },
      { Title: 'MAP CLASS-2', SubjectID: 1, lessonURL: 'map-class-2' },
      { Title: 'MAP CLASS-3', SubjectID: 1, lessonURL: 'map-class-3' },
      { Title: 'MAP CLASS-4', SubjectID: 1, lessonURL: 'map-class-4' },
      { Title: 'MAP CLASS-5', SubjectID: 1, lessonURL: 'map-class-5' },
      { Title: 'MAP CLASS-6', SubjectID: 1, lessonURL: 'map-class-6' },
    ]
  };

  const data2 = [
    {
      Image: civilcard1,
      CategoryTag: "News, Environment and Ecology",
      Title: "COP27 - India, China, Brazil, South Africa oppose 'carbon border tax'",
      PublishDate: "Nov 20, 2022 05:32 PM",
      WrittenBy: "Insight IAS",
      Description: "India, China, Brazil, and South Africa have jointly opposed the 'carbon border tax' proposed by the European Union, calling it discriminatory and against the principles of equity.",
      ImageAlt: "COP-27-India-China-Brazil-South-Africa-oppose-carbon-border-tax",
    },
    {
      Image: civilcrad2,
      CategoryTag: "News, Economy",
      Title: "India’s falling exports: Manufacturing takes the biggest hit",
      PublishDate: "Nov 18, 2022 04:04 PM",
      WrittenBy: "Insight IAS",
      Description: "India's merchandise exports have witnessed a significant decline, with the manufacturing sector being the most affected due to global economic slowdown and supply chain disruptions.",
      ImageAlt: "Indias-falling-exports-Manufacturing-takes-the-biggest-hit",
    },
    {
      Image: civilcard3,
      CategoryTag: "News, Miscellaneous",
      Title: "As Mission Prarambh’s Vikram-S rocket soars into space, recalling Vikram Sarabhai",
      PublishDate: "Nov 17, 2022 02:19 PM",
      WrittenBy: "Insight IAS",
      Description: "The successful launch of Vikram-S, India's first privately developed rocket, marks a new era in the Indian space sector, paying tribute to the vision of Vikram Sarabhai.",
      ImageAlt: "As-Mission-Prarambhs-Vikram-S-rocket-soars-into-space",
    },
    {
      Image: civilcard4,
      CategoryTag: "News, Sci and Tech",
      Title: "What ‘viral spillover risk’ means, and how it could lead to new pandemics",
      PublishDate: "Nov 16, 2022 01:46 PM",
      WrittenBy: "Insight IAS",
      Description: "Scientists are warning about the increasing risk of viral spillover from wild animals to humans, which could potentially trigger future pandemics if not monitored closely.",
      ImageAlt: "What-viral-spillover-risk-means-and-how-it-could-lead-to-new-pandemics",
    },
    {
      Image: civilcard5,
      CategoryTag: "News, International Relations",
      Title: "Pakistan is off FATF’s grey list: what does that mean",
      PublishDate: "Nov 15, 2022 11:36 PM",
      WrittenBy: "Insight IAS",
      Description: "The Financial Action Task Force (FATF) has removed Pakistan from its 'grey list', a move that is expected to boost the country's economy and international standing.",
      ImageAlt: "Pakistan-is-off-FATFs-grey-list-what-does-that-mean",
    }
  ]

  return (
    <>
      <Helmet>
        <title>Map Classes for History Optional | By S. Baliyan Sir | Insight IAS</title>
      </Helmet>

      {/* Civil History Optional Section Start */}
      <section className='history-optional-background dynamic-course pt-3'>
        {/* Civil Batch Section Start */}
        <CivilBatch courseData={data} />
        {/* Civil Batch Section End */}
      </section>
      <CivilButton courseData={data} newsData={data2} componentName={componentName} />
      {/* Civil History Optional Section End */}
    </>
  )
}

export default CivilOpt;